import { call, put } from 'redux-saga/effects';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  sendClientApprovalFailure,
  sendClientApprovalSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { SendClientApprovalRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { sendClientApproval } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { updateSubmissionLog } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { sendTifdToClientFromReturnSaga } from 'store/tifd/sagas/sendTifdToClientSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* sendClientApprovalSaga(
  action: SendClientApprovalRequestAction
) {
  const sentTifd: boolean = yield call(sendTifdToClientFromReturnSaga, action);
  if (sentTifd) return;

  try {
    let err: ApiError | null;
    const { dataLogId, emailData, mappingId } = action.payload;

    const response: ApiResponse = yield call(
      sendClientApproval,
      dataLogId,
      emailData,
      mappingId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.AWAITING_CLIENT_APPROVAL));

    yield put(sendClientApprovalSuccess());
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        'AWAITING_CLIENT_APPROVAL',
        dataLogId
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(sendClientApprovalFailure());
  }
}
